// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".generic-confirm .content-area .subtitle{color:#7b8794;font-size:16px}.generic-confirm .buttons .danger-button{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
